import { useMemo } from 'react';
import { calcBookingBreakdown, BookingBreakdown } from 'utils/calcBookingBreakdown';

export const useBookingBreakdown = (trip?: any): BookingBreakdown | null => {
  const breakdown = useMemo(() => {
    if (!trip) return null;
    return calcBookingBreakdown(trip);
  }, [trip]);

  return breakdown;
};